import { WindowPageForm, KitService, TabFormContainer } from '@adista/window-kit-ui';
import { ApiModelService, ApiModel } from '@adista/common';
import { ReplaySubject } from 'rxjs';
import { AfterViewInit, ViewChildren, QueryList } from '@angular/core';
import { CustomTabFormContainer } from '../forms/custom-tab-form-container';
import { MatTabChangeEvent } from '@angular/material/tabs';

export abstract class CustomWindowPageForm<TItem extends ApiModel, TService extends ApiModelService<TItem>>
  extends WindowPageForm<ApiModel, TService> implements AfterViewInit {
  protected _mainTab: CustomTabFormContainer;
  replayMainId: ReplaySubject<number> = new ReplaySubject<number>(1);
  @ViewChildren('tabForm') protected tabsComponents: QueryList<CustomTabFormContainer>;

  constructor(
    protected apiService: TService,
    kit: KitService
  ) {
    super(apiService, kit);
  }

  onTabChange(event: MatTabChangeEvent): void {
    super.onTabChange(event);
    this.loadAll();
  }

  protected loadAll(): void {
    this.tabsComponents.forEach((tab: CustomTabFormContainer) => {
      if (tab.isActiveTab) {
        tab.loadAll();
      }
    });
  }
}
